import inMemoryJWT from './inMemoryJWT';
import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import { apiBaseUrl } from './config';

/* Configuration Templates (ET12_CONFIGURATION_MONITORING_SPEC.md section 8/21/22 - device
   SDK repo root). Modeled on firmwaresDataProvider.js, but - unlike that one - implements a
   real update() (the backend supports editing name/description/ignore_patterns and optionally
   replacing the base backup archive, POST /config_templates/:id/update, not a REST PUT - see
   the backend route's own comment for why it's a POST). */
export default function configTemplatesDataProvider(url) {
    const apiUrl = url || apiBaseUrl;

    const httpClient = (requestUrl, p_options) => {
        const options = {
            headers: new Headers({ Accept: 'application/json' }),
            ...p_options
        };
        const token = inMemoryJWT.getToken();
        if (token) {
            options.headers.set('x-access-token', `${token}`);
        }
        return fetchUtils.fetchJson(requestUrl, options);
    };

    function toRaListResult(response) {
        if (response.status < 200 || response.status >= 300) {
            return Promise.reject(new Error("HTTP error" + response.status));
        }
        var ret_data = JSON.parse(response.body);
        var result = {};
        var records = Array.isArray(ret_data.result) ? ret_data.result : [];
        result.data = records.map(function(r) { return { ...r, id: r._id }; });
        result.total = ret_data.count != undefined ? ret_data.count : records.length;
        return result;
    }

    function toRaOneResult(response) {
        if (response.status < 200 || response.status >= 300) {
            return Promise.reject(new Error("HTTP error" + response.status));
        }
        var ret_data = JSON.parse(response.body);
        var result = {};
        if (ret_data.result) {
            result.data = ret_data.result;
            result.data.id = ret_data.result._id;
        }
        return result;
    }

    function buildFormData(data) {
        var formData = new FormData();
        if (data.name != undefined) {
            formData.append('name', data.name);
        }
        if (data.description != undefined) {
            formData.append('description', data.description);
        }
        if (data.ignore_patterns != undefined) {
            formData.append('ignore_patterns', data.ignore_patterns);
        }
        if (data.base_backup_file && data.base_backup_file.rawFile) {
            formData.append('base_backup_file', data.base_backup_file.rawFile);
        }
        return formData;
    }

    return {
        getList: (resource, params) => {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify(params.filter),
            };
            return httpClient(`${apiUrl}/config_templates?${stringify(query)}`).then(toRaListResult);
        },

        getOne: (resource, params) => {
            return httpClient(`${apiUrl}/config_templates/${params.id}`).then(toRaOneResult);
        },

        getMany: (resource, params) => {
            const query = { filter: JSON.stringify({ ids: params.ids }) };
            return httpClient(`${apiUrl}/config_templates?${stringify(query)}`).then(function(response) {
                var ret_data = JSON.parse(response.body);
                var result = {};
                var records = Array.isArray(ret_data.result) ? ret_data.result : [];
                result.data = records.map(function(r) { return { ...r, id: r._id }; });
                return result;
            });
        },

        getManyReference: (resource, params) => Promise.reject('getManyReference not implemented'),

        create: (resource, params) => {
            return httpClient(`${apiUrl}/config_templates`, {
                method: 'POST',
                body: buildFormData(params.data),
            }).then(toRaOneResult);
        },

        update: (resource, params) => {
            return httpClient(`${apiUrl}/config_templates/${params.id}/update`, {
                method: 'POST',
                body: buildFormData(params.data),
            }).then(toRaOneResult);
        },

        delete: (resource, params) => {
            return httpClient(`${apiUrl}/config_templates/${params.id}`, {
                method: 'DELETE',
            }).then(function(response) {
                var ret_data = JSON.parse(response.body);
                var result = {};
                if (ret_data.result == "ok") {
                    result.data = params.previousData || { id: params.id };
                }
                return result;
            });
        },

        deleteMany: (resource, params) => {
            return Promise.all(params.ids.map(function(id) {
                return httpClient(`${apiUrl}/config_templates/${id}`, { method: 'DELETE' });
            })).then(function() {
                return { data: params.ids };
            });
        },

        updateMany: (resource, params) => Promise.reject('updateMany not implemented'),
    };
}
